export enum RequestTimeFilterEnum {
    From0To30DaysDescription = '0-30 Days',
    From0To30Days = 1,
    From31To60DaysDescription = '31-60 Days',
    From31To60Days = 2,
    Above60DaysDescription = 'Above 60 Days',
    Above60Days = 3,
    CustomDescription = 'Custom',
    Custom = 4,
}
